import { MedicareBridgeChecklistOption } from './medicare-bridge.types';

/** Checklist label for a stored route code. Falls back to the code when no list has it. */
export function medicareBridgeRouteLabel(
  value: string | null | undefined,
  ...routeLists: Array<
    readonly MedicareBridgeChecklistOption[] | null | undefined
  >
): string | null {
  const route = value?.trim();
  if (!route) return null;
  for (const routes of routeLists) {
    const label = routes?.find((item) => item.value === route)?.label;
    if (label) return label;
  }
  return route;
}
